import React, { useState } from "react";
import useStockData from "../hooks/useStockData";
import CategoryModal from "../components/CategoryModal";
import EditCategoryModal from "../components/EditCategoryModal";
import EditProductModal from "../components/EditProductModal";
import ProductModalOnStockPage from "../components/ProductModalOnStockPage";
import CategoryList from "../components/CategoryList";
import ProductList2 from "../components/ProductList2";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal"; // Importáljuk az új modalt
import { getUserRole } from "../utils/Auth";
import { useTheme } from "../context/ThemeContext";

const StocPage = () => {
  const userRole = getUserRole();
  const {
    categories,
    products,
    selectedCategory,
    fetchProductsByCategory,
    addCategory,
    updateCategory,
    deleteCategory,
    updateProduct,
    addProduct,
    deleteProduct,
  } = useStockData();
  
  const { darkMode } = useTheme();
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [categoryToEdit, setCategoryToEdit] = useState(null);
  const [isProductEditModalOpen, setIsProductEditModalOpen] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const [isProductModalOnStockPage, setIsProductModalOnStockPage] =
    useState(false);

  const [showCategoryActions, setShowCategoryActions] = useState(false);
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] =
    useState(false); // Új állapot a megerősítő modalhoz
  const [categoryToDelete, setCategoryToDelete] = useState(null); // Az aktuálisan törlendő kategória
  const [deleteSuccess, setDeleteSuccess] = useState(null);

  const handleCategorySelect = (categoryId, categoryName) => {
    setSelectedCategoryName(categoryName);
    fetchProductsByCategory(categoryId);
  };

  const toggleCategoryActions = () => {
    setShowCategoryActions(!showCategoryActions);
  };

  const handleDeleteCategory = (categoryId) => {
    setCategoryToDelete(categoryId); // Beállítjuk a törlendő kategóriát
    setIsConfirmDeleteModalOpen(true); // Megnyitjuk a megerősítő modált
  };

  const confirmDeleteCategory = async () => {
    try {
      await deleteCategory(categoryToDelete);
      setDeleteSuccess("✅ Categoria a fost ștearsă cu succes!"); // ✅
      setTimeout(() => setDeleteSuccess(null), 2000); // Automatikus eltüntetés
    } catch (error) {
      console.error("Hiba a kategória törlésekor:", error);
    } finally {
      setIsConfirmDeleteModalOpen(false);
    }
  };
  

  const cancelDeleteCategory = () => {
    setIsConfirmDeleteModalOpen(false); // Bezárjuk a modalt törlés lemondásával
  };

  return (
    <div className={`p-6 min-h-screen ${darkMode ? "bg-gray-900" : "bg-gray-200"}`}>
      <h2
        className={`text-5xl font-semibold mb-4 text-center ${
          darkMode ? "text-white" : "text-black"
        }`}
      >
        Categorii
      </h2>

      {userRole === "Admin" && (
        <div className="flex justify-start items-center mb-4 gap-4">
          <button
            onClick={toggleCategoryActions}
            className={`px-4 py-4 rounded-3xl ${
              darkMode ? "bg-gray-700 text-white" : "bg-blue-600 text-white"
            }`}
          >
            {showCategoryActions ? "Ascunde" : "Adaugă/Modifică categorie"}
          </button>

          {showCategoryActions && (
            <button
              onClick={() => setIsCategoryModalOpen(true)}
              className={`px-4 py-4 rounded-3xl ${
                darkMode ? "bg-green-700 text-white" : "bg-green-600 text-white"
              }`}
            >
              + Adaugă Categorie
            </button>
          )}
        </div>
      )}

      <div
        className={`flex ${
          selectedCategory ? "justify-start" : "justify-center"
        } transition-all duration-300`}
      >
        <CategoryList
          categories={categories}
          openCategoryModal={() => setIsCategoryModalOpen(true)}
          openEditCategoryModal={() => setIsEditModalOpen(true)}
          setCategoryToEdit={setCategoryToEdit}
          selectedCategory={selectedCategory}
          showCategoryActions={userRole === "Admin" ? showCategoryActions : false}
          handleDeleteCategory={userRole === "Admin" ? handleDeleteCategory : null}
          deleteSuccess={deleteSuccess}
        />

        {selectedCategory && (
          <ProductList2
            products={products}
            selectedCategoryName={selectedCategoryName}
            setIsProductModalOnStockPage={setIsProductModalOnStockPage}
            setProductToEdit={setProductToEdit}
            setIsProductEditModalOpen={setIsProductEditModalOpen}
            deleteProduct={deleteProduct}
          />
        )}
      </div>

      {userRole === "Admin" && (
        <>
          <CategoryModal
            isOpen={isCategoryModalOpen}
            onClose={() => setIsCategoryModalOpen(false)}
            addCategory={addCategory}
          />
          <EditCategoryModal
            isOpen={isEditModalOpen}
            onClose={() => setIsEditModalOpen(false)}
            category={categoryToEdit}
            updateCategory={updateCategory}
          />
          <EditProductModal
            isOpen={isProductEditModalOpen}
            onClose={() => setIsProductEditModalOpen(false)}
            product={productToEdit}
            updateProduct={updateProduct}
          />
          <ProductModalOnStockPage
            isOpen={isProductModalOnStockPage}
            onClose={() => setIsProductModalOnStockPage(false)}
            addProduct={addProduct}
            selectedCategoryId={selectedCategory}
          />
          <ConfirmDeleteModal
            isOpen={isConfirmDeleteModalOpen}
            onClose={cancelDeleteCategory}
            onConfirm={confirmDeleteCategory}
          />
        </>
      )}
    </div>
  );
};

export default StocPage;